angular.module("digiexam.invite", []);
